import Polling from './polling.connect.js'

export default Polling
